module.exports = __webpack_public_path__ + "static/img/bck.53afc51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bck.jpg
// module id = lv+l
// module chunks = 128